module.exports = __webpack_public_path__ + "img/Discord bots.33088834.jpg";